var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Map component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconMap extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.44157 1.12497L2.89626 2.40564C1.84797 2.64773 1.10547 3.58126 1.10547 4.65714V20.1825C1.10547 21.6688 2.48813 22.7685 3.93617 22.4341L3.9362 22.4341L8.61374 21.3538L15.1972 22.8707C15.3131 22.9011 15.4362 22.9036 15.556 22.876L21.1045 21.5946L21.1045 21.5946C22.1528 21.3524 22.8953 20.4189 22.8953 19.343V3.81762C22.8953 2.33144 21.5126 1.2317 20.0646 1.56612L20.0646 1.56613L15.3878 2.64622L8.78513 1.12488C8.6746 1.0989 8.55823 1.09802 8.44479 1.12422L8.44157 1.12497ZM9.36356 19.9873V2.79746L14.6372 4.01258V21.2024L9.36356 19.9873ZM7.86353 2.79795V19.9876L3.59869 20.9726C3.0906 21.0899 2.60547 20.704 2.60547 20.1825V4.65714C2.60547 4.27965 2.86599 3.95211 3.23379 3.86717L7.86353 2.79795ZM16.1372 4.01261V21.2022L20.7669 20.1331L20.7669 20.133C21.1348 20.0481 21.3953 19.7205 21.3953 19.343V3.81762C21.3953 3.29617 20.9101 2.91033 20.4021 3.02765L20.4021 3.02765L16.1372 4.01261Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconMap.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconMap.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconMap.prototype, "size", void 0);
if (customElements.get('cat-icon-map') === undefined) {
    customElements.define('cat-icon-map', BlocksIconMap);
}
